export const transparentPng =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mOcPn2hGAAFgwHnKg1wnAAAAABJRU5ErkJggg==';
